<template>
    <div>
        <div>
            <img :src="imgSrc" alt />
        </div>
        <div class="control">
            <span class="playBtn" :class="{'rotate':playing}" @click="onPlay">{{playing?'〓':'▶'}}</span>
            <div>
                <mt-range v-model="rangeValue" :disabled="imgList.length == 0" :min="0" :max="imgList.length-1" :barHeight="5">
                    <div slot="end" style="padding-left:10px;">{{time}}</div>
                </mt-range>
            </div>
        </div>
        <div class="station">
            <div
                v-for="(station,index) in stationList"
                :key="index"
                :class="{'active':index == stationIndex}"
                @click="onClick(index)"
            >{{station.name}}</div>
        </div>
        <div class="kepu">
            <label>云图科普</label>
            <div>{{kepu}}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            baseUrl:'',
            playing: false,
            rangeValue: 0,
            interVal: null, //定时器
            stationIndex: 0,
            stationList: [
                { name: "彩色", id:8 },
                { name: "红外", id:20 },
                { name: "水汽", id:21 },
                { name: "可见光", id:22 }
            ],
            imgList: [
                // { src: "snow", time: "01:00" },
            ],
            kepu: "由气象卫星自上而下观测到的地球上的云层覆盖和地表面特征的图像。利用卫星云图可以识别不同的天气系统，确定它们的位置，估计其强度和发展趋势，为天气分析和天气预报提供依据。"
        };
    },
    created(){
        this.baseUrl = document.location.origin;
    },
    mounted(){
        this.getData();
    },
    computed: {
        time() {
            if(this.imgList.length === 0){
                return '';
            }
            return this.imgList[this.rangeValue].time;
        },
        imgSrc() {
            if(this.imgList.length === 0){
                return '';
            }
            return this.baseUrl + this.imgList[this.rangeValue].src;
        }
    },
    methods: {
        onPlay() {
            if(this.imgList.length === 0){
                return;
            }
            this.playing = !this.playing;
            if (this.playing) {
                this.interVal = setInterval(() => {
                    this.rangeValue++;
                    if (this.rangeValue > this.imgList.length - 1) {
                        this.rangeValue = 0;
                    }
                }, 1000);
            } else {
                clearInterval(this.interVal);
            }
        },
        onClick(index){
            this.stationIndex = index;
            if(this.playing){
                this.playing = false;
                clearInterval(this.interVal);
            }
            this.rangeValue = 0;
            this.imgList = [];
            
            this.getData();
        },
        getData(){
            const id = this.stationList[this.stationIndex].id;
            this.ajax('wxInterface/findRadarOrCloud',{id},dataList => {
                if(dataList === undefined){
                    return;
                }
                this.imgList = dataList;
            });
        },
    }
};
</script>

<style scoped>
div {
    color: white;
}
img {
    width: 100%;
}
.control {
    padding: 10px;
    display: flex;
    align-items: center;
}
.control > div {
    flex: 1;
    padding-left: 10px;
}
.playBtn {
    display: inline-block;
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    border-radius: 50%;
    background-color: #4caf50;
}
.rotate {
    transform: rotate(90deg);
}

.station {
    padding: 10px;
}
.station > div {
    display: inline-block;
    border-radius: 5px;
    width: 25%;
    text-align: center;
    padding: 5px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.station > div.active {
    background-color: #00bcd4;
}

.kepu {
    padding: 10px;
}
.kepu > label {
    display: block;
    font-size: large;
    color: aqua;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding: 5px 0;
}

.kepu > div {
    margin-top: 10px;
    text-indent: 2rem;
}
</style>